import type { IDeviceService } from "./IDeviceService";
import type { ApiAllSensor, ApiDevice, ApiReturnDevice} from "@highimpact-frontend/api-types";
import { api_config } from "../../../api-commons";


class DeviceService implements IDeviceService {

    async add(params: ApiAllSensor): Promise<number> {
        const response = await api_config.post('/devices', params);
        return response.data;
    }

    async associateMeasureTypesToDevice(measureTypes: number[], deviceId: number)  {
        const params = {
            "device_id": deviceId,
            "measure_type_ids": measureTypes
        }
        console.info('Sending params:', JSON.stringify(params, null, 2));
        const response = await api_config.post('/device_measure-types', params);
        return response.data;
    }

    async UpdateDeviceMeasureTypesAssociation (measureTypes: number[], deviceId: number) {
        const params = {
            "device_id": deviceId,
            "measure_type_ids": measureTypes
        }
        console.info('Sending params:', JSON.stringify(params, null, 2));
        const response = await api_config.put('/device_measure-types', params);
        return response.data;
    }

    async update(id: number, params: ApiDevice): Promise<ApiReturnDevice> {
        const response = await api_config.put(`/devices/${id}`, params);
        return response.data;
    }

    async delete(id: number): Promise<ApiReturnDevice> {
        const response = await api_config.delete(`/devices/${id}`);
        return response.data;
    }

}

const instance = new DeviceService();
export default instance;